export default "__VITE_ASSET__8783b217__"